import {Component, inject, Input} from '@angular/core';
import {GraphicUtils, SpringRestService} from '@aiknow-srl/aik-angular-sdk';
import {Router} from '@angular/router';
import {PlatformLocation} from '@angular/common';
import {MatSidenav} from '@angular/material/sidenav';
import {environment} from '../../../environments/environment';
import {ChangePasswordCB} from '../../Ope/User/ChangePasswordCB';
import {UserLogoutCB} from '../../Ope/User/UserLogoutCB';
import {ExportAllCustomersDevicesCB} from "../../Ope/User/ExportAllCustomersDevicesCB";
import {UserService} from "../../Services/Ope/User.service";
import {BaseComponent} from "../common/BaseComponent";
import {BaseDialogComponent} from "../common/BaseDialogComponent";

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent extends BaseComponent {

  private be = inject(SpringRestService);
  private route: Router = inject(Router);
  private platformLocation: PlatformLocation = inject(PlatformLocation);
  private userService: UserService = inject(UserService);

  graphicUtils = GraphicUtils;

  env = environment.typeOfEnv;

  languages = this.gmService.localeList;

  public isAlarmedProduct = new Array<string>();

  @Input('componentName') componentName?: string;
  @Input('drawer') drawer!: MatSidenav;

  /**
   * Print FE and BE environments in topbar
   */
  printEnvironments(): string {
    let res = '';

    if (environment.typeOfEnv !== 'prod' || this.gmService.envIdLabel !== '') {
      res = `${res} [`;
    }

    if (environment.typeOfEnv !== 'prod') {
      res = `${res} FE: ${environment.typeOfEnv}`;
    }

    if (environment.typeOfEnv !== 'prod' && this.gmService.envIdLabel !== '') {
      res = `${res} -`;
    }

    if (this.gmService.envIdLabel !== '') {
      res = `${res} BE: ${this.gmService.envIdLabel}`;
    }

    if (environment.typeOfEnv !== 'prod' || this.gmService.envIdLabel !== '') {
      res = `${res} ]`;
    }

    return res;

  }

  /**
   * Logout function
   */
  logout(): void {

    const cb = new UserLogoutCB();

    this.userService.userLogout(cb).subscribe(
      () => {
        this.innerLogoutOperations();
      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );
  }

  private innerLogoutOperations() {
    this.be.doLogout();
    localStorage.removeItem('language');
    this.route.navigateByUrl('', {skipLocationChange: true});
  }

  /**
   * Opens another browser tab with the documentation
   */
  gotoDoc(): void {
    const baseHref = this.platformLocation.getBaseHrefFromDOM();
    const path = window.location.origin + baseHref + 'doc/';
    window.open(path, '_blank');
  }

  /**
   * Changes the used language
   * @param locale the selected locale
   */
  changeLanguage(locale: string | undefined): void{

    if (!!locale) {
      this.translate.use(locale);
      this.be.setLanguage(locale);
      localStorage.setItem('language', locale);
    }

  }

  /**
   * Opens the change Password dialog
   */
  openChangePassword(): void {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.translate.get('CHANGE_PASSWORD.CHANGE_PASSWORD_SUCCESSFUL').subscribe(
            (result) => {
              this.gmService.openInfoSnackbar(result);

              this.innerLogoutOperations();
            }
          );
        }
      }, error => {
        console.log(error);
      }
    );
  }

  /**
   * Tokenizes the appVersion returning only the first part
   */
  getAppVersion(): string {
    // Version is in the form x.y.z_buildData
    // Returning only x.y.z
    if (this.gmService.appVersion !== undefined) {
      return this.gmService.appVersion.split('_')[0];
    } else {
      return '';
    }

  }

  tbLogin() {
    this.gmService.redirectToThingsBoard(this.be.getToken());
  }

  exportAllCustomerDeviced() {

    const cb = new ExportAllCustomersDevicesCB();

    this.userService.exportAllCustomersDevices(cb).subscribe(
      () => {

        this.gmService.downloadFile(cb.o.filename, cb.o.mimeType, cb.o.binary);

      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );
  }

  openDeviceMap() {
    const url = window.location.href + "publicMap";
    console.log(url);
    window.open(url, '_blank');
  }
}


/*--------------------------------
    CHANGE PASSWORD COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'change-password-dialog.html',
  selector: 'app-change-password-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class ChangePasswordDialogComponent extends BaseDialogComponent<ChangePasswordDialogComponent> {

  username?: string;
  // @ts-ignore
  oldPassword: string;
  // @ts-ignore
  newPassword: string;
  // @ts-ignore
  confirmPassword: string;

  private userService = inject(UserService);

  constructor() {
    super();
    this.username = this.gmService.user.email;
  }

  changePassword(): void {

    if (!this.passwordsMismatch()) {

      const cb = new ChangePasswordCB();
      cb.i.currentPassword = this.oldPassword;
      cb.i.newPassword = this.newPassword;

      this.userService.changePassword(cb).subscribe(
        () => {
          this.closeDialog(true);
        }, error => {
          this.gmService.openErrorSnackbar(error);
        }
      );
    } else {
      this.gmService.openTranslatedErrorSnackbar('ERROR.PASSWORDS_MISMATCH');
    }

  }

  passwordsMismatch() {
    const res = this.confirmPassword !== this.newPassword;
    console.log(res)
    return res;
  }
}
